'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import type { OutageBanner, OutageBannerSite } from '@sola/sdg-sdk/lib/outage-banner/schema.ts';
import { fetchOutageBanners } from '@sola/sdg-sdk/utils/routes.ts';
import { COOKIE_NAME_OUTAGE_DISMISSED } from '@sola/shared-utils/constants.ts';
import { addDismissedBannerId, getDismissedBannerIds } from '@sola/shared-utils/cookies.ts';
import { OutageRibbon } from './outage-ribbon.tsx';
type OutageBannerClientProps = {
  site: OutageBannerSite;
};
export const OutageBannerClient: React.FC<OutageBannerClientProps> = t0 => {
  const $ = _c(8);
  const {
    site
  } = t0;
  const [banner, setBanner] = useState();
  let t1;
  let t2;
  if ($[0] !== site) {
    t1 = () => {
      fetchOutageBanners(site, true).then(bannerData => {
        const items = bannerData?.items ?? [];
        const dismissed = getDismissedBannerIds(COOKIE_NAME_OUTAGE_DISMISSED);
        const firstVisible = items.find(b => !b.id || !dismissed.includes(b.id));
        setBanner(firstVisible);
      });
    };
    t2 = [site];
    $[0] = site;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!banner) {
    return;
  }
  let t3;
  if ($[3] !== banner.id) {
    t3 = () => {
      if (banner.id) {
        addDismissedBannerId(COOKIE_NAME_OUTAGE_DISMISSED, banner.id);
      }
      setBanner(undefined);
    };
    $[3] = banner.id;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClose = t3;
  let t4;
  if ($[5] !== banner || $[6] !== handleClose) {
    t4 = <OutageRibbon {...banner} onClose={handleClose} />;
    $[5] = banner;
    $[6] = handleClose;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};